import { TopBarContainer } from '@econsult/econsult-ui/dist/components/TopBar/TopBarStyles';
import { HiLogoWithTextIcon } from 'assets';
import { FeedbackModal } from 'components/Feedback/FeedbackModal';
import GenericModalTrigger from 'components/Modal/GenericModalTrigger';
import { TopBarUserActions } from 'components/TopBar/TopBarUserActions';
import { useAppState } from 'store/configureStore';
import { FreeTimeLeft } from './freeTimer';
import {
  FeedbackButton,
  LogoTitleGroup,
  RightBarContainer,
  TopBarBox,
  TopBarMiddleContainer,
  TopBarWrapper,
} from './styles';
import Wallet from './Wallet';

export const TopBar = () => {
  const {
    featureFlags: { TEMP_SUMMARISER_PAYMENT_ENABLED },
    wallet: { subscription },
  } = useAppState();
  const canUseApp = Boolean(TEMP_SUMMARISER_PAYMENT_ENABLED || subscription);
  return (
    <TopBarBox data-automation="TopBarBox">
      <TopBarWrapper data-automation="TopBar">
        <TopBarContainer shown>
          <LogoTitleGroup>
            <HiLogoWithTextIcon />
          </LogoTitleGroup>
          {canUseApp && (
            <TopBarMiddleContainer>
              <FreeTimeLeft />
              <Wallet />
            </TopBarMiddleContainer>
          )}
          <TopBarUserActions>
            <RightBarContainer>
              <GenericModalTrigger
                trigger={
                  <FeedbackButton
                    fillStyle="filled"
                    size="small"
                    state="secondary"
                    id="feedback-summary-button"
                    data-automation="Feedback-Summary"
                  >
                    {' '}
                    Give feedback
                  </FeedbackButton>
                }
                title="Give us feedback"
              >
                {closeModal => <FeedbackModal closeModal={closeModal} />}
              </GenericModalTrigger>
            </RightBarContainer>
          </TopBarUserActions>
        </TopBarContainer>
      </TopBarWrapper>
    </TopBarBox>
  );
};
